var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Element/Misc/Circle Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 16,
    cy: 16,
    r: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-9---Search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.6--User-result---edit",
    transform: "translate(-181.000000, -622.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-info",
    transform: "translate(149.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timeline",
    transform: "translate(32.000000, 349.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element/Misc/Circle-Icon",
    transform: "translate(0.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Base",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.2,
    mask: "url(#mask-2)",
    fill: "#4B7BFC"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "Element/Icon/Message",
    mask: "url(#mask-2)",
    fill: "#4B7BFC"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 10.000000)",
    id: "\\uD83C\\uDFA8-Icon-color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27272727,10.1818182 L1.27272727,2.016 L7.00254545,6.53990909 L12.7272727,1.96 L12.7279091,10.1818182 L1.27272727,10.1818182 Z M11.5493636,1.27272727 L6.99745455,4.91463636 L2.38445455,1.27272727 L11.5493636,1.27272727 Z M12.7272727,0 L1.27272727,0 C0.570818182,0 0,0.570818182 0,1.27272727 L0,10.1818182 C0,10.8837273 0.570818182,11.4545455 1.27272727,11.4545455 L12.7272727,11.4545455 C13.4291818,11.4545455 14,10.8837273 14,10.1818182 L14,1.27272727 C14,0.570818182 13.4291818,0 12.7272727,0 L12.7272727,0 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.fc88e684d14103c95d10622b97eacc9a.svg";
export { ForwardRef as ReactComponent };